var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "permission-form" }, [
    _c(
      "div",
      { staticClass: "animated fadeIn" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-card",
                  { attrs: { "header-tag": "header", "footer-tag": "footer" } },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { attrs: { className: "fa fa-align-justify" } }),
                      _c("strong", [_vm._v(_vm._s(_vm.$t("edit")))]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-actions" })
                    ]),
                    _vm._v(" "),
                    _vm.item.uuid != null
                      ? _c(
                          "b-form",
                          { staticClass: "row" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "9", "align-self": "center" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("name"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      attrs: {
                                        "aria-describedby": "nameFeedback"
                                      },
                                      model: {
                                        value: _vm.item.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "name", $$v)
                                        },
                                        expression: "item.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("description"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.description,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "description", $$v)
                                        },
                                        expression: "item.description"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("code"),
                                      "label-cols": 3,
                                      horizontal: true
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "form-control",
                                      model: {
                                        value: _vm.item.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.item, "code", $$v)
                                        },
                                        expression: "item.code"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("config")) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "label",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.config_content",
                                                modifiers: {
                                                  config_content: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "switch switch-sm switch-text switch-info float-right mb-0",
                                            on: {
                                              click: _vm.updateConfigStatus
                                            }
                                          },
                                          [
                                            _vm.configStatus == 1
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.configStatus == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      { attrs: { id: "config_content" } },
                                      [
                                        _vm._l(_vm.item.configs, function(
                                          config,
                                          c
                                        ) {
                                          return _c(
                                            "b-row",
                                            { key: config.id },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("group"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.group,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "group",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.group"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("key"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.key,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "key",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.key"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("value"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass:
                                                          "form-control",
                                                        model: {
                                                          value: config.value,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              config,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "config.value"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "1" } },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "danger"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeConfig(c)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash-o"
                                                      })
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: { click: _vm.addConfig }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-plus"
                                                    }),
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(_vm.$t("config"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "header" },
                                        slot: "header"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("customizes")) +
                                            "\n                  "
                                        ),
                                        _c(
                                          "label",
                                          {
                                            directives: [
                                              {
                                                name: "b-toggle",
                                                rawName:
                                                  "v-b-toggle.customize_content",
                                                modifiers: {
                                                  customize_content: true
                                                }
                                              }
                                            ],
                                            staticClass:
                                              "switch switch-sm switch-text switch-info float-right mb-0",
                                            on: {
                                              click: _vm.updateCustomizeStatus
                                            }
                                          },
                                          [
                                            _vm.customizeStatus == 1
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-up"
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.customizeStatus == 0
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-chevron-down"
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      { attrs: { id: "customize_content" } },
                                      [
                                        _vm._l(_vm.item.customizes, function(
                                          customize,
                                          c
                                        ) {
                                          return _c(
                                            "b-row",
                                            { key: customize.id },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("group"),
                                                        "label-cols": 3,
                                                        horizontal: true
                                                      }
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        attrs: {
                                                          options: _vm.groups
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.item.customizes[
                                                              c
                                                            ].group,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.item
                                                                .customizes[c],
                                                              "group",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.customizes[c].group"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "danger"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.removeGroup(c)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-minus"
                                                      }),
                                                      _vm._v(
                                                        "  " +
                                                          _vm._s(
                                                            _vm.$t("group")
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "9" } },
                                                [
                                                  _vm._l(
                                                    _vm.item.customizes[c]
                                                      .fields,
                                                    function(field, f) {
                                                      return _c(
                                                        "b-row",
                                                        { key: field.id },
                                                        [
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "name"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-input",
                                                                    {
                                                                      staticClass:
                                                                        "form-control",
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ]
                                                                            .name,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ],
                                                                            "name",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].name"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "tag"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-select",
                                                                    {
                                                                      attrs: {
                                                                        options:
                                                                          _vm.tags
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.updateTag(
                                                                            c,
                                                                            f
                                                                          )
                                                                        }
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ].tag,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ],
                                                                            "tag",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].tag"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "type"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs: {
                                                                            options:
                                                                              _vm.types
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .type,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "type",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.type"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-group",
                                                                {
                                                                  attrs: {
                                                                    label: _vm.$t(
                                                                      "class"
                                                                    ),
                                                                    "label-cols": 3,
                                                                    horizontal: true
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-input",
                                                                    {
                                                                      staticClass:
                                                                        "form-control",
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .item
                                                                            .customizes[
                                                                            c
                                                                          ]
                                                                            .fields[
                                                                            f
                                                                          ]
                                                                            .attribute
                                                                            .class,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .item
                                                                              .customizes[
                                                                              c
                                                                            ]
                                                                              .fields[
                                                                              f
                                                                            ]
                                                                              .attribute,
                                                                            "class",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "item.customizes[c].fields[f].attribute.class"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "date_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "default"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "masked-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          attrs: {
                                                                            type:
                                                                              "text",
                                                                            name:
                                                                              "date",
                                                                            mask: [
                                                                              /\d/,
                                                                              /\d/,
                                                                              "/",
                                                                              /\d/,
                                                                              /\d/,
                                                                              "/",
                                                                              /\d/,
                                                                              /\d/,
                                                                              /\d/,
                                                                              /\d/
                                                                            ],
                                                                            guide: true,
                                                                            placeholderChar:
                                                                              "_",
                                                                            showMask: true,
                                                                            keepCharPositions: true
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .default,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "default",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.default"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_box"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "default"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .default,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "default",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.default"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "text_box" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "text_area"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "place_holder"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .place_holder,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "place_holder",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.place_holder"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "switch"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "check_value"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .check_value,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "check_value",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.check_value"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "switch"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "uncheck_value"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .uncheck_value,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "uncheck_value",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.uncheck_value"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "text_area"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "rows"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "b-form-input",
                                                                        {
                                                                          staticClass:
                                                                            "form-control",
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .customizes[
                                                                                c
                                                                              ]
                                                                                .fields[
                                                                                f
                                                                              ]
                                                                                .attribute
                                                                                .rows,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute,
                                                                                "rows",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.customizes[c].fields[f].attribute.rows"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                          "select"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "6"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "multiple"
                                                                        ),
                                                                        "label-cols": 3,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "c-switch",
                                                                        _vm._b(
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "icon",
                                                                              variant:
                                                                                "primary",
                                                                              checked:
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .multiple,
                                                                              value: 1,
                                                                              uncheckedValue: 0
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .multiple,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .item
                                                                                    .customizes[
                                                                                    c
                                                                                  ]
                                                                                    .fields[
                                                                                    f
                                                                                  ]
                                                                                    .attribute,
                                                                                  "multiple",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.customizes[c].fields[f].attribute.multiple"
                                                                            }
                                                                          },
                                                                          "c-switch",
                                                                          {
                                                                            on:
                                                                              "\uf00c",
                                                                            off:
                                                                              "\uf00d"
                                                                          },
                                                                          false
                                                                        )
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "select" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "check_box" ||
                                                          _vm.item.customizes[c]
                                                            .fields[f].tag ==
                                                            "radio_group"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "12"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-form-group",
                                                                    {
                                                                      attrs: {
                                                                        label: _vm.$t(
                                                                          "options"
                                                                        ),
                                                                        "label-cols": 2,
                                                                        horizontal: true
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "table",
                                                                        {
                                                                          staticClass:
                                                                            "table"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "thead",
                                                                            [
                                                                              _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "th",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "text"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "th",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.$t(
                                                                                            "value"
                                                                                          )
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "th"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "tbody",
                                                                            [
                                                                              _vm._l(
                                                                                _vm
                                                                                  .item
                                                                                  .customizes[
                                                                                  c
                                                                                ]
                                                                                  .fields[
                                                                                  f
                                                                                ]
                                                                                  .attribute
                                                                                  .options,
                                                                                function(
                                                                                  option,
                                                                                  o
                                                                                ) {
                                                                                  return _c(
                                                                                    "tr",
                                                                                    {
                                                                                      key:
                                                                                        option.id
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              staticClass:
                                                                                                "form-control",
                                                                                              model: {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .item
                                                                                                    .customizes[
                                                                                                    c
                                                                                                  ]
                                                                                                    .fields[
                                                                                                    f
                                                                                                  ]
                                                                                                    .attribute
                                                                                                    .options[
                                                                                                    o
                                                                                                  ]
                                                                                                    .text,
                                                                                                callback: function(
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .item
                                                                                                      .customizes[
                                                                                                      c
                                                                                                    ]
                                                                                                      .fields[
                                                                                                      f
                                                                                                    ]
                                                                                                      .attribute
                                                                                                      .options[
                                                                                                      o
                                                                                                    ],
                                                                                                    "text",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                                expression:
                                                                                                  "item.customizes[c].fields[f].attribute.options[o].text"
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              staticClass:
                                                                                                "form-control",
                                                                                              model: {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .item
                                                                                                    .customizes[
                                                                                                    c
                                                                                                  ]
                                                                                                    .fields[
                                                                                                    f
                                                                                                  ]
                                                                                                    .attribute
                                                                                                    .options[
                                                                                                    o
                                                                                                  ]
                                                                                                    .value,
                                                                                                callback: function(
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .item
                                                                                                      .customizes[
                                                                                                      c
                                                                                                    ]
                                                                                                      .fields[
                                                                                                      f
                                                                                                    ]
                                                                                                      .attribute
                                                                                                      .options[
                                                                                                      o
                                                                                                    ],
                                                                                                    "value",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                                expression:
                                                                                                  "item.customizes[c].fields[f].attribute.options[o].value"
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _c(
                                                                                            "b-button",
                                                                                            {
                                                                                              attrs: {
                                                                                                size:
                                                                                                  "sm",
                                                                                                variant:
                                                                                                  "danger"
                                                                                              },
                                                                                              on: {
                                                                                                click: function(
                                                                                                  $event
                                                                                                ) {
                                                                                                  _vm.removeOption(
                                                                                                    c,
                                                                                                    f,
                                                                                                    o
                                                                                                  )
                                                                                                }
                                                                                              }
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "i",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "fa fa-minus"
                                                                                                }
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    {
                                                                                      attrs: {
                                                                                        colspan:
                                                                                          "2"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "b-button",
                                                                                        {
                                                                                          attrs: {
                                                                                            size:
                                                                                              "sm",
                                                                                            variant:
                                                                                              "success"
                                                                                          },
                                                                                          on: {
                                                                                            click: function(
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.addOption(
                                                                                                c,
                                                                                                f
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "i",
                                                                                            {
                                                                                              staticClass:
                                                                                                "fa fa-plus"
                                                                                            }
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            2
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "danger"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.removeField(
                                                                        c,
                                                                        f
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "fa fa-minus"
                                                                  }),
                                                                  _vm._v(
                                                                    "  " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "field"
                                                                        )
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "clearfix"
                                                                },
                                                                [_c("hr")]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "b-row",
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: { cols: "12" }
                                                        },
                                                        [
                                                          _c(
                                                            "b-button",
                                                            {
                                                              attrs: {
                                                                variant:
                                                                  "success"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.addField(
                                                                    c
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-plus"
                                                              }),
                                                              _vm._v(
                                                                "  " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "field"
                                                                    )
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "clearfix" },
                                                    [_c("hr")]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "success"
                                                    },
                                                    on: { click: _vm.addGroup }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-plus"
                                                    }),
                                                    _vm._v(
                                                      "  " +
                                                        _vm._s(_vm.$t("group"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text-center",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: _vm.model + "_list" } } },
                          [
                            _c("b-button", { attrs: { variant: "default" } }, [
                              _c("i", { staticClass: "fa fa-arrow-left" }),
                              _vm._v(" " + _vm._s(_vm.$t("back")))
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uuid != null &&
                        _vm.$auth.check(_vm.model + ".update")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.updateItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(" " + _vm._s(_vm.$t("update")))
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uuid == null &&
                        _vm.$auth.check(_vm.model + ".create")
                          ? _c(
                              "b-button",
                              {
                                attrs: { variant: "success" },
                                on: { click: _vm.createItem }
                              },
                              [
                                _c("i", { staticClass: "fa fa-save" }),
                                _vm._v(" " + _vm._s(_vm.$t("save")))
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32332b3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32332b3e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/client/Form.vue
// module id = 1187
// module chunks = 0